import React from 'react';
import type { IconProps } from '../types';

export const IconMPR = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="info-mpr"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="mpr"
        transform="translate(1.5, 1.5) scale(2.0, 2.0)" // 减小 scale 以细化线条
        stroke="currentColor"
        strokeWidth="0.5" // 减小 strokeWidth 以细化线条
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          id="Path-1"
          d={`
            M8.56 6.665v-0.262c0-0.139-0.132-0.25-0.295-0.25H7.71v0.762h0.548c0.16 0 0.295-0.114 0.295-0.25z
          `}
        ></path>
        <path
          id="Path-2"
          d={`
            M10.406 2.953L5.744 5.657a0.083 0.083 0 0 0-0.04 0.071l-0.016 5.37c0 0.062 0.069 0.103 0.124 0.071L10.471 8.464a0.083 0.083 0 0 0 0.04-0.071l0.016-5.37c0-0.062-0.07-0.103-0.123-0.071z
            m-1.475 5.301c-0.023 0.011-0.046 0.017-0.069 0.017-0.052 0-0.101-0.027-0.127-0.075l-0.546-0.993h-0.462v0.923c0 0.08-0.065 0.145-0.145 0.145s-0.145-0.065-0.145-0.145v-2.104c0-0.003 0.002-0.006 0.002-0.009 0-0.003-0.002-0.005-0.002-0.007a0.144 0.144 0 0 1 0.145-0.145h0.692c0.323 0 0.584 0.241 0.584 0.54v0.262c0 0.225-0.149 0.418-0.362 0.499l0.491 0.895c0.039 0.07 0.013 0.158-0.056 0.197z
            M5.466 5.729L0.797 3.034c-0.055-0.03-0.123 0.009-0.123 0.071l-0.015 5.371c0 0.029 0.015 0.056 0.04 0.071l4.676 2.701c0.054 0.03 0.123-0.009 0.123-0.071l0.015-5.371a0.083 0.083 0 0 0-0.04-0.071z
            m-1.247 2.413c0 0.08-0.065 0.145-0.145 0.145a0.144 0.144 0 0 1-0.145-0.145v-1.625l-0.727 1.211c-0.026 0.045-0.074 0.071-0.124 0.071s-0.099-0.026-0.124-0.071l-0.727-1.211v1.625c0 0.08-0.065 0.145-0.145 0.145s-0.145-0.065-0.145-0.145v-2.162c0-0.08 0.065-0.145 0.145-0.145 0.066 0 0.121 0.046 0.137 0.109 0.002 0.002 0.003 0.002 0.003 0.003l0.856 1.426 0.856-1.426c0-0.002 0.002-0.002 0.003-0.003 0.016-0.062 0.069-0.109 0.137-0.109 0.08 0 0.145 0.065 0.145 0.145v2.162z
          `}
        ></path>
        <path
          id="Path-3"
          d={`
            M10.293 2.715L5.624 0.011c-0.025-0.015-0.056-0.015-0.082 0L0.897 2.715c-0.054 0.032-0.054 0.11 0.002 0.141l4.675 2.701c0.026 0.015 0.056 0.015 0.082 0l4.645-2.701c0.055-0.032 0.055-0.11 0-0.141z
            m-4.006-0.331c0 0.302-0.266 0.549-0.594 0.549h-0.561v0.934c0 0.08-0.065 0.145-0.145 0.145a0.144 0.144 0 0 1-0.145-0.145V1.704c0-0.081 0.064-0.145 0.145-0.145 0.005 0 0.009 0.002 0.015 0.003h0.691c0.327 0 0.594 0.247 0.594 0.549v0.271z
          `}
        ></path>
      </g>
    </g>
  </svg>
);

export default IconMPR;
